import React from "react";
import { Redirect, Route } from "react-router-dom";
import PrivateRoute from "@common/components/route/PrivateRoute";
import { Switch } from "react-router-dom";
import { NotificationEntireBox } from "@icoach/notifications/components";
import { NOTIFICATIONS_ROUTER } from "@icoach/router/routerPath";
import { NotFoundPage } from "@error/";

const NotificationsPage = props => {
	return (
		<Switch>
			<PrivateRoute title="全部通知" path={NOTIFICATIONS_ROUTER.ENTIRE} as={NotificationEntireBox} />
			<PrivateRoute title="會籍到期" path={NOTIFICATIONS_ROUTER.MEMBERSHIP_EXPIRE} as={NotificationEntireBox} />
			<PrivateRoute title="會籍移入" path={NOTIFICATIONS_ROUTER.TRANSFERIN} as={NotificationEntireBox} />
			<PrivateRoute title="會籍移出" path={NOTIFICATIONS_ROUTER.TRANSFEROUT} as={NotificationEntireBox} />
			<PrivateRoute title="循環訂單" path={NOTIFICATIONS_ROUTER.CYCLE_PURCHASE} as={NotificationEntireBox} />
			<PrivateRoute title="發票處理" path={NOTIFICATIONS_ROUTER.INVOICE} as={NotificationEntireBox} />
			<PrivateRoute title="暫存文書" path={NOTIFICATIONS_ROUTER.TEMP_DOC} as={NotificationEntireBox} />
			<PrivateRoute title="新版本" path={NOTIFICATIONS_ROUTER.VERSION_UPDATE} as={NotificationEntireBox} />
			<Route path="/">
				<Redirect to={NOTIFICATIONS_ROUTER.ENTIRE} />
			</Route>
			<PrivateRoute path="*" as={NotFoundPage} />
		</Switch>
	);
};

export default NotificationsPage;
